<script>
import _ from "lodash";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import PageAlerts from "@/components/page-alerts";

export default {
  page: {
    title: "Next Level Promotion",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, PageAlerts },
  data() {
    return {
      title: "Next Level Promotion",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Promotion",
          active: true,
        },
      ],
      filterStds: {
        year: "",
        class: "",
        toclass: "",
        nextClassFetch: "",
        course: "",
      },
      customNextClasses: {},
      pageErrors: {
        promotion: "",
      },
    };
  },
  computed: {
    ...mapGetters("classes", [
      "AllCourses",
      "AllClasses",
      "AllClassStreams",
      "SaveStatus",
      "getPromotedStudents",
      "getFilteredPromotions",
      "promotionStatus",
      "getNextClassStudents",
      "CustomClasses",
    ]),
    ...mapGetters("marks", ["getYears"]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  methods: {
    ...mapActions({
      FetchClasses: "classes/fetchClasses",
      FetchCourses: "classes/fetchCourses",
      FetchStreams: "classes/fetchStreams",
      FetchClassStreams: "classes/fetchClassStreams",
      FetchYears: "marks/fetchYear",
      PromoteStudents: "classes/promoteStudents",
      PromoteFailedStudents: "classes/promoteFailedStudents",
      FilterPromotionStudents: "classes/filterPromotionStudents",
      FetchNextClassStudents: "classes/fetchNextClassStudents",
      FetchCustomClasses: "classes/fetchCustomClasses",
    }),
    submitPromotion() {
      if (this.getFilteredPromotions.promotedStd.length > 0) {
        this.PromoteStudents({
          studentDetails: this.getFilteredPromotions.promotedStd,
          promotionDetails: this.filterStds,
        });
      }
    },
    promoteFailedStd(studentDetails) {
      this.PromoteFailedStudents({
        studentDetails,
        promotionDetails: this.filterStds,
      });
    },
    failFailedStudent(studentDetails) {
      this.PromoteFailedStudents({
        studentDetails,
        promotionDetails: this.filterStds,
        failed: true
      });
    },
    filterStudents() {
      this.FilterPromotionStudents(this.filterStds);
    },
    //fetch next class students
    nextClassStudents() {
      this.filterStds.nextClassFetch = 1;
      this.FetchNextClassStudents(this.filterStds);
    },

    //on promotion class select.
    checkPromotionClass() {
      if (this.filterStds.toclass != "") {
        this.nextClassStudents();
      }
    },
    getNextLeve() {
      const levels = _.cloneDeep(this.CustomClasses);
      let index = this.CustomClasses.findIndex(
        (course) => course.id === this.filterStds.class
      );
      // Check if the index is found
      if (index !== -1) {
        // Remove items from the selected index (inclusive) to the end
        this.customNextClasses = levels.splice(index + 1);
      }
    },

    setYear() {
      this.filterStds.year = new Date().getFullYear();
    },
    fetchClasses() {
      const selectedCourse = { course: this.filterStds.course };
      this.FetchCustomClasses(selectedCourse);
    },
  },
  created() {
    this.FetchYears();
    this.FetchClasses();
    this.FetchStreams();
    this.setYear();
    this.FetchCourses();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('student_promotion')
        )
      "
    >
      <div class="col-md-12">
        <div class="col-md-12">
          <router-link
            to="/pass-mark"
            role="button"
            class="btn btn-sm btn-primary float-end mb-3 mt-2"
          >
            Pass Marks
          </router-link>
        </div>
      </div>
      <PageAlerts
        title="PLEASE NOTE !!!"
        primaryMsg="Actions in this page (Students Promotion) are not reversable, Please be careful in all actions on this page..."
        alertType="warning"
      />
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              <button
                v-if="promotionStatus"
                name=""
                id=""
                class="btn float-end btn-sm btn-secondary"
                disabled
                role="button"
              >
                <b-spinner
                  class="text-white"
                  small
                  label="Fetching Data..."
                ></b-spinner>
                Promoting Students...
              </button>
              <button
                v-else-if="
                  !this.getFilteredPromotions.promotedStd ||
                    getFilteredPromotions.promotedStd.length < 1
                "
                name=""
                id=""
                class="btn float-end btn-sm btn-secondary"
                disabled
                role="button"
              >
                Promote Student
                <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
              </button>
              <button
                v-else
                name=""
                id=""
                class="btn float-end btn-sm btn-secondary"
                href="#"
                @click="submitPromotion()"
                role="button"
              >
                Promote Student
                <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
              </button>
            </div>
            <h6 class="card-title">Select Students For Promotion</h6>
            <hr />
            <form @submit.prevent="filterStudents()">
              <div class="row mb-4">
                <div class="form-group col-md-6 mt-2">
                  <label>Course <small class="text-danger">*</small></label>
                  <div class="form-group">
                    <select
                      required
                      class="form-control form-control-sm"
                      v-model="filterStds.course"
                      @change="fetchClasses()"
                    >
                      <option value="" selected disabled>Select Course</option>
                      <option
                        v-for="(course, index) in AllCourses"
                        :key="index"
                        :value="course.id"
                      >
                        {{ course.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group col-md-6 mt-2">
                  <label>From Level <small class="text-danger">*</small></label>
                  <div class="form-group">
                    <select
                      class="form-control form-control-sm"
                      required
                      v-model="filterStds.class"
                      :disabled="filterStds.course ? false : true"
                      @change="checkPromotionClass(), getNextLeve()"
                    >
                      <option value="" selected disabled>From Level</option>
                      <option
                        v-for="(classes, index) in CustomClasses"
                        :key="index"
                        :value="classes.id"
                      >
                        {{ classes.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group col-md-6 mt-2">
                  <label>Next Level <small class="text-danger">*</small></label>
                  <div class="form-group">
                    <select
                      :class="
                        pageErrors.promotion
                          ? 'form-control form-control-sm is-invalid'
                          : 'form-control form-control-sm'
                      "
                      required
                      v-model="filterStds.toclass"
                      :disabled="filterStds.class ? false : true"
                      @change="checkPromotionClass()"
                    >
                      <option value="" selected disabled>To Level</option>
                      <option
                        v-for="(classes, index) in customNextClasses"
                        :key="index"
                        :value="classes.id"
                      >
                        {{ classes.name }}
                      </option>
                    </select>
                  </div>
                  <small v-if="pageErrors.promotion" class="text-danger">
                    {{ pageErrors.promotion }}</small
                  >
                </div>
                <div class="col-md-6 mt-3">
                  <button
                    type="submit"
                    size="sm"
                    disabled
                    class="btn btn-sm btn-outline-primary"
                    v-if="SaveStatus"
                  >
                    <b-spinner
                      variant="primary"
                      small
                      label="Fetching Data..."
                    ></b-spinner>
                    Fetching Students...
                  </button>
                  <button
                    v-else-if="pageErrors.promotion != ''"
                    type="submit"
                    disabled
                    size="sm"
                    class="btn btn-sm btn-outline-primary"
                  >
                    <i class="fa fa-filter" aria-hidden="true"></i>
                    Filter Students
                  </button>
                  <button
                    v-else
                    type="submit"
                    size="sm"
                    class="btn btn-sm btn-outline-primary"
                  >
                    <i class="fa fa-filter" aria-hidden="true"></i>
                    Filter Students
                  </button>
                </div>
              </div>
            </form>
            <b-tabs
              justified
              nav-class="nav-tabs-custom"
              content-class="p-3 text-muted"
            >
              <b-tab active>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fa fa-check" aria-hidden="true"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">
                    <i
                      class="fa fa-check-circle text-primary"
                      aria-hidden="true"
                    ></i>
                    Ready For Promotion
                    <span
                      v-if="getFilteredPromotions.promotedStd"
                      class="badge bg-success"
                      >{{
                        getFilteredPromotions
                          ? getFilteredPromotions.promotedStd.length
                          : null
                      }}</span
                    >
                  </span>
                </template>
                <strong> Students Ready For Promotion</strong>
                <div class="row mt-3">
                  <div
                    class="text-muted col-md-6 mt-0"
                    v-for="(student,
                    index) in getFilteredPromotions.promotedStd"
                    :key="index"
                  >
                    <i
                      class="fa fa-check align-middle text-success me-1"
                      aria-hidden="true"
                    ></i>
                    <strong>{{
                      student.enrolment_details.student.name
                    }}</strong>
                    <br />
                    <span
                      v-for="(results, index) in student.std_results"
                      :key="index"
                    >
                      {{ results.subject.name }}: {{ results.results.marks }}
                    </span>
                  </div>
                </div>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block"
                    ><i
                      class="fa fa-times-circle text-danger"
                      aria-hidden="true"
                    ></i>
                    Below Pass Mark
                    <small class="text-danger">(Failed) </small>
                    <span
                      v-if="getFilteredPromotions.failedStd"
                      class="badge bg-danger"
                      >{{
                        getFilteredPromotions
                          ? getFilteredPromotions.failedStd.length
                          : null
                      }}</span
                    ></span
                  >
                </template>
                <strong> Students Who Are Below Pass mark </strong>
                <div class="row mt-3">
                  <div
                    class="text-muted mt-2 col-md-6"
                    v-for="(student, index) in getFilteredPromotions.failedStd"
                    :key="index"
                  >
                    <i
                      class="fa fa-times-circle align-middle text-danger me-1"
                      aria-hidden="true"
                    ></i>
                    <strong>{{
                      student.enrolment_details.student.name
                    }}</strong>
                    <br />
                    <span
                      v-for="(results, index) in student.std_results"
                      :key="index"
                    >
                      {{ results.subject.name }}:
                      {{ results.results ? results.results.marks : "Missed" }}
                    </span><br><br>
                    <div class="row">
                      <b-button-group>
                        <button
                        v-if="promotionStatus || SaveStatus"
                        name=""
                        id=""
                        disabled
                        class="btn btn-sm btn-default"
                        role="button"
                      >
                        Please Wait...
                      </button>
                        <template v-else>
                          <button
                          class="btn btn-sm btn-outline-danger"
                          @click="failFailedStudent(student)"
                          v-b-modal.fail-student-modal
                          >
                          <i class="fa fa-times" aria-hidden="true"> Repeat Level</i>
                        </button>
                        <button
                            class="btn btn-sm btn-success"
                            @click="promoteFailedStd(student)"
                          >
                            <i class="fa fa-check" aria-hidden="true"> Promote</i>
                          </button>
                        </template>
                      </b-button-group>
                    </div>
                    <hr>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              <h5 class="text-primary">
                Current Students in The Selected Level
              </h5>
              <hr />
            </div>
            <div class="row">
              <div class="col-lg-9 col-sm-8">
                <div class="text-muted">
                  <p
                    class="mb-1"
                    v-for="(student, index) in getNextClassStudents.promotedStd"
                    :key="index"
                  >
                    <i
                      class="
                        mdi mdi-circle-medium
                        align-middle
                        text-primary
                        me-1
                      "
                    ></i>
                    {{ student.student.name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
